import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// icons
import { PiMicrophoneStage } from "react-icons/pi";
import { GrCirclePlay } from "react-icons/gr";
import { IoTimeOutline } from "react-icons/io5";
import { useMusic } from "../../context/MusicContext";

const SongCard = React.memo(({item}) => {
  const musicContext = useMusic();
    const navigate = useNavigate();

    const handleDetail = (id) => {
        navigate(`/music/detail/songs/${id}`, { state: { type: "many", normal : true } });
    }

  return (
    <div
      className="flex space-x-4 my-10 border-b-black"
      onClick={() => handleDetail(item.id)}
    >
      <div className="flex-none w-16">
        <img src={item.image} alt="image" className="rounded" />
      </div>
      <div className="grow truncate">
        <span className="text-sm mt-2 tracking-wider ">{item.title}</span>
        <div>
          <PiMicrophoneStage className="inline mr-2" />
          <span className="text-xs mt-2 truncate">{item.desc}</span>
          {item.duration ? (
            <div className="mx-2 inline">
              <IoTimeOutline className="inline mr-2" />
              <span className="text-xs mt-2 truncate">{item.duration}</span>
            </div>
          ) : null}
        </div>
      </div>
      <div className="flex-none w-16 flex items-center justify-center">
        <GrCirclePlay className="text-yellow-500" fontSize={40} />
      </div>
    </div>
  );
});

export default SongCard;
